import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { Route, Routes } from 'react-router-dom';
import WellcomePage from './pages/WellcomePage/WellcomePage';
import { AUTH_URL, CONFIRM_PAGE_URL, FILTERS_URL, LOGOUT_URL, RATES_URL, VACANCIES_URL } from './utils/consts';
import RatesPage from './pages/RatesPage/RatesPage';
import VacanciesPage from './pages/VacanciesPage/VacanciesPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import AuthPage from './pages/AuthPage/AuthPage';
import { ConfirmPage } from './pages/ConfirmPage/ConfirmPage';

function App() {
  return (
    <div className="App">
      <Header/>
      <main>  
        <Routes>
          <Route path='/' element={<WellcomePage/>}/>
          <Route path={RATES_URL} element={<RatesPage/>}/>
          <Route path={VACANCIES_URL} element={<VacanciesPage/>}/>
          <Route path={FILTERS_URL} element={<SettingsPage/>}/>
          <Route path={AUTH_URL} element={<AuthPage/>}/>
          <Route path={CONFIRM_PAGE_URL} element={<ConfirmPage/>}/>
        </Routes>
      </main>
      <Footer/>
    </div>
  );
}

export default App;
